export default __webpack_public_path__ + "media/images/recrutement-rouge-aa3334a07f67c046afd71054b8fa6933.png";